module.exports = __webpack_public_path__ + "img/r2c2.f1f18174.jpg";